import { GET_DEPARTMENT_DETAIL_ADMINTOOLS, GET_DEPARTMENT_OPTIONS, RESET_DEPARTMENT_DETAIL_ADMINTOOLS } from "shared/constants/ActionTypes";

const initialState = {
  detailDepartment:null,
  optionsDepartment:null,
  
};

const departmentAdmintoolsReducer = (state = initialState, action) => {
  switch (action.type) {
  
      case GET_DEPARTMENT_DETAIL_ADMINTOOLS:
        return {
          ...state,
          detailDepartment: action.payload,
        };
        case GET_DEPARTMENT_OPTIONS:
          return {
            ...state,
            optionsDepartment: action.payload,
          };
        default: {
          return state;
        }

        case RESET_DEPARTMENT_DETAIL_ADMINTOOLS:
          return initialState
  }
};

export default departmentAdmintoolsReducer;
